export default "https://assets.egbcdn.net/assets/packs/_/images/table/line-loader-50228541244bf22c3ab9d07cd2728966.gif";